import { render, staticRenderFns } from "./DimensionItem.vue?vue&type=template&id=8ec1a3ec&scoped=true&"
import script from "./DimensionItem.vue?vue&type=script&lang=js&"
export * from "./DimensionItem.vue?vue&type=script&lang=js&"
import style0 from "./DimensionItem.vue?vue&type=style&index=0&id=8ec1a3ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec1a3ec",
  null
  
)

export default component.exports